module.exports = ".stock_info_box p {\n    font-size: 0.9rem;\n}\n"